export default "__VITE_ASSET__CbfLz8Hy__"